import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DifficultyMeter from "../../gui/difficultyMeter";
import door from "../../res/generic_door.png";
import doorSfx from "../../res/sfx/Walking_OneShot.wav";
import song from "../../res/music/Insidious.mp3";
import {
  changeSong,
  getDifficulty,
  GetNextRooms,
  GlobalVars,
  playOneShot,
} from "../room_handler";

const bannerUrl =
  "https://i.pinimg.com/564x/19/03/ac/1903ac84fc701a99da5441c6cc647a2c.jpg";
const doorUrl =
  "https://i.pinimg.com/564x/19/03/ac/1903ac84fc701a99da5441c6cc647a2c.jpg";

const PARAMS = { floors: 6 };

var nextRooms;

const Stairs2 = () => {
  const [floor, setFloor] = useState(0);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    changeSong(song);
    PARAMS.floors = Math.ceil(Math.max(Math.random() * 6, 2));
    nextRooms = GetNextRooms(Stairs2_Obj);
  }, []);

  if (!nextRooms) {
    nextRooms = GetNextRooms(Stairs2_Obj);
  }

  const parseInput = () => {
    setFloor(floor + 1);
  };

  const getComponent = () => {
    let component;
    //console.log(PARAMS.pass);
    component = <Flight rooms={nextRooms} floor={floor} output={parseInput} />;
    return component;
  };

  return (
    <div className="room">
      <DifficultyMeter
        value={GlobalVars.depth}
        ramp={GlobalVars.difficultyRamp}
        maxRamp={GlobalVars.maxRamp}
      />
      <h1>Stairs (Down)</h1>
      <img className="banner" src={bannerUrl} />
      <p className="descriptionText">
        A flight of stone spiral stairs winds its way downward. You cannot see
        beyond the bend. Whatever Fell Magic keeps you from retreating also
        sbottoms you from taking a single stair backwards. If one stair is
        taken, one must continue to descend.
      </p>
      {getComponent()}
    </div>
  );
};

const Entryway = () => {
  const navigate = useNavigate();
  return (
    <button
      key={Stairs2_Obj.name}
      className="entry"
      onClick={() => {
        playOneShot(doorSfx);
        navigate(Stairs2_Obj.route);
      }}
    >
      <img src={Stairs2_Obj.image} />
      <span className="entryText">A stone stairway leading down</span>
    </button>
  );
};

export var Stairs2_Obj = {
  name: "Stairs2",
  room: Stairs2,
  entry: Entryway,
  route: "/halloween2022/stairs2",
  exits: 6,
  prob: 5,
  image: doorUrl,
};

export default Stairs2;

//input rooms
const Flight = (props) => {
  const submitHandler = (e) => {
    e.preventDefault();
    props.output();
  };

  const getFloorText = () => {
    if (props.floor == 0) {
      return (
        <p>
          Unable to turn back, and with no way to go but down, you take your
          first steps. At the bottom of the flight you see a door. You can take
          this door, or you can continue down the stairs to the next door, but
          you cannot return.
        </p>
      );
    } else if (props.floor >= PARAMS.floors - 1) {
      return (
        <p>
          You continue down another flight of stairs. At the bottom of the
          flight you see a door. There are no more stairs downwards. You *must*
          take this door.
        </p>
      );
    } else {
      return (
        <p>
          You continue down another flight of stairs. At the bottom of the
          flight you see a door. You can take this door, or you can continue
          down the stairs to the next door, but you cannot return.
        </p>
      );
    }
  };

  //console.log(PARAMS.floors);

  return (
    <div>
      <div className="roomText">
        {getFloorText()}
        {props.floor < PARAMS.floors - 1 ? (
          <button className="inputSubmit" onClick={submitHandler}>
            Continue Downwards
          </button>
        ) : (
          ""
        )}
      </div>
      <div className="nextHolder">{props.rooms[props.floor].entry()}</div>
    </div>
  );
};
